module.exports = __webpack_public_path__ + "multi-date.2b523ec15ff7d0a4bfd9697776debbbc.png";